export function omitGraphErrorValues(values = []) {
  return values.map((value) => {
    if (value && typeof value === 'object' && 'y' in value) {
      const numericValue = Number(value.y);
      return !Number.isFinite(numericValue) || numericValue === -1
        ? { ...value, y: null }
        : value;
    }
    if (value === null || value === undefined || value === '') return null;

    const numericValue = Number(value);
    return !Number.isFinite(numericValue) || numericValue === -1 ? null : value;
  });
}

export function getValidGraphValues(values = []) {
  return omitGraphErrorValues(values)
    .map((value) => (value && typeof value === 'object' ? value.y : value))
    .filter((value) => value !== null)
    .map(Number);
}

export function getPaddedGraphBounds(
  values,
  padding,
  { minimumLimit = -Infinity, maximumLimit = Infinity } = {}
) {
  const validValues = getValidGraphValues(values);
  if (validValues.length === 0) return null;

  return {
    minimum: Math.max(minimumLimit, Math.min(...validValues) - padding),
    maximum: Math.min(maximumLimit, Math.max(...validValues) + padding)
  };
}
